<template>
  <div>
    <HeroImageOrVideo v-if="imageSrc" :image="imageSrc">
      <div class="container flex items-center h-full flex-wrap">
        <BarText :text="entry.textOverlay" tag="h1" class="fluid-4xl leading-none" />
      </div>
    </HeroImageOrVideo>
    <ContentBlocks :entry="entry" :social-media-accounts="socialMediaAccounts" />
  </div>
</template>
<script>
import gql from 'graphql-tag';
import HeroImageOrVideo from '@/components/common/HeroImageOrVideo';
import BarText from '@/components/BarText.vue';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';

export const StoriesHomePageFragment = gql`
  fragment StoriesHomePageFragment on storiesHome_Entry {
    title
    textOverlay
    seoTopics
    headerImageOrVideo {
      url
      kind
    }
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
  }
  ${ContentBlocksMatrixFragment}
`;

export default defineNuxtComponent({
  name: 'StoriesHomePage',
  components: { HeroImageOrVideo, BarText, ContentBlocks },
  props: {
    entry: {
      type: Object,
      default: () => {},
    },
    socialMediaAccounts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    imageSrc() {
      return this.entry?.headerImageOrVideo?.length ? this.entry?.headerImageOrVideo[0] : null;
    },
  },
});
</script>
